<template>
  <a-modal
    title="外雇机械"
    :width="700"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :maskClosable="false"
    @cancel="handleCancel"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="id" :labelCol="labelCol" :wrapperCol="wrapperCol" v-show="false">
          <a-input :disabled="showable" v-decorator="['id']" />
        </a-form-item>
        <a-form-item
          label="客户名称"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['customerName', {rules: [{required: true, message: '请输入客户名称'}]}]" />
        </a-form-item>
        <a-form-item
          label="机械类别"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['type', {rules: [{required: true, message: '请输入机械类别'}]}]" />
        </a-form-item>
        <a-form-item
          label="单号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['orderNumber', {rules: [{required: true, message: '请输入单号'}]}]" />
        </a-form-item>
        <a-form-item
          label="计费方式"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group
            @change="onChange"
            v-decorator="['chargeMode', {rules: [{required: true, message: '请输入机械类别'}],initialValue:'1'}]"
          >
            <a-radio value="1">记时</a-radio>
            <a-radio value="0">记项</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item
          v-show="false"
          label="总工作时间"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['totalHour', {rules: [{required: false, message: '保留两位小数'}]}]" />
        </a-form-item>
        <a-form-item
          label="工作时间明细"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :hidden="isShow"
        >
          <div>
            <machine-date
              :child-date-list="dateList"
              @getChileDeleteList="(ChileDeleteList) => getChileDeleteList(ChileDeleteList)"
              @childChangeDate="(childDateList) => childChangeDate(childDateList)"
            ></machine-date>
          </div>
        </a-form-item>
        <a-form-item
          label="单价"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          :hidden="isShow"
        >
          <a-input-number
            :precision="3"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入单价(按小时计费)"
            v-decorator="['price', {rules: [{required: !isShow, message: '请输入单价(按小时计费)'}]}]" />
        </a-form-item>
        <a-form-item
          :hidden="!isShow"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="项"
        >
          <a-input
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['item', {rules: [{required: isShow, message: '请输入'}]}]" />
        </a-form-item>
        <a-form-item
          :hidden="!isShow"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
          label="总金额"
        >
          <a-input-number
            :precision="2"
            style="width: 100%"
            :min="0"
            :disabled="showable"
            placeholder="请输入总金额"
            v-decorator="['amount', {rules: [{required: isShow, message: '请输入总金额'}]}]" />
        </a-form-item>
        <a-form-item
          label="工作内容及工作量"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['content', {rules: [{required: true, message: '请输入工作内容及工作量'}]}]"
          />
        </a-form-item>
        <a-form-item
          label="备注"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :disabled="showable"
            placeholder="请输入"
            v-decorator="['remark']"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <div>
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button key="forward" :loading="confirmLoading" type="primary" @click="handleOk">保存</a-button>
      </div>
    </template>
  </a-modal>
</template>

<script>
import pick from 'lodash.pick'
import AFormItem from 'ant-design-vue/es/form/FormItem'
import myDate from './myDate'
import machineDate from './machineDate'
export default {
  name: 'DailyOutMachineAdd',
  components: { AFormItem, myDate, machineDate },
  data () {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 14 }
      },
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      editable: false,
      addable: false,
      theKey: 0,
      showable: false,
      dateList: [], // 控制时间选框的个数
      count: 0,
      deleteMaterialTimeDetailList: [],
      totalHour: 0, // 总时长
      showTime: { // 格式化分钟的时间选矿
        format: 'HH:mm'
      },
      value: '1',
      isShow: false,
      amount: 0,
      chargeMode: '1'
    }
  },
  methods: {
    // 获取用户消息
    edit (child, type) {
      this.visible = true
      if (type === 'edit') {
        // 根绝具体状态，给isShow分配状态
        this.isShow = String(child.chargeMode) !== '1'
        this.type = type
        this.theKey = child.key
        this.dateList = child.dateList
        this.chargeMode = child.chargeMode
        this.dateList.forEach(da => {
        //   // 设置唯一标识符key
          da.key = this.count
          this.count = this.count + 1
        })
      }
      if (type && type === 'add') {
        this.type = type
        this.isShow = false
      }
      const {
        form: { setFieldsValue, resetFields }
      } = this
      if (type === 'add') {
        resetFields()
      } else if (type === 'edit') {
        const pickFiled = [
          'id',
          'customerName',
          'type',
          'totalHour',
          'content',
          'remark',
          'chargeMode',
          'amount',
          'price',
          'item',
          'orderNumber'
        ]
        this.$nextTick(() => {
          setFieldsValue(pick(child, pickFiled))
        })
      }
    },
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    // 结束保存用户信息
    handleOk () {
      // 过滤不正确的数据
      this.dateList = this.dateList.filter(item => item.leadTime !== undefined)
      // 修改总时长
      // 此处 totalHour必须清零，否则他点击确认按钮时，校验失败也会累加totalHour
      this.totalHour = 0
      this.dateList.forEach(da => {
        if (da.leadTime !== null && da.leadTime !== undefined) {
          this.totalHour = this.totalHour + da.leadTime
        }
      })
      this.form.validateFields(async (err, values) => {
        values.dateList = this.dateList
        values.totalHour = this.totalHour
        // 如果是计时且填写单价则在此处计算总总金额
        if (values.price && String(values.chargeMode) === '1') {
          values.amount = ((this.totalHour / 60.00).toFixed(2) * values.price).toFixed(2)
        }
        if (!err) {
          if (this.type === 'add') {
            this.$emit('changeData', values)
          } else if (this.type === 'edit') {
            values.key = this.theKey
            this.$emit('editData', values)
            if (this.deleteMaterialTimeDetailList.length !== 0) {
              this.$emit('changeDelete', this.deleteMaterialTimeDetailList)
            }
          }
          this.visible = false
          this.clear()
        }
      })
    },
    handleCancel () {
      this.visible = false
      this.clear()
      setTimeout(() => {
        this.addable = false
        this.showable = false
        this.editable = false
      }, 200)
    },
    clear () {
      this.count = 0
      this.dateList = []
      this.totalHour = 0
      this.form.setFieldsValue({ price: undefined })
      this.form.setFieldsValue({ amount: undefined })
      this.form.setFieldsValue({ item: undefined })
    },
    // 接收子组件得dateList
    childChangeDate (childDateList) {
      this.dateList = childDateList
    },
    // 接收子组件得删除列表
    getChileDeleteList (ChileDeleteList) {
      this.deleteMaterialTimeDetailList = ChileDeleteList
    },
    onChange (e) {
      // 0 时 记项
      if (String(e.target.value) === '0') {
        this.isShow = true
      }
      // 1 时 计时
      if (String(e.target.value) === '1') {
        this.isShow = false
      }
      this.clear()
      // console.log('radio checked', e.target.value)
    }
  }
}
</script>

<style scoped>

</style>
